export default "__VITE_ASSET__26c03aa5__"